import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';
import Nearby from './nearBy';
import { TweenLite } from 'gsap';

Snappy.Component.ApproachPointer = class ApproachPointer extends Snappy.BaseComponent {
    static get tagName() {
        return 'approach-pointer';
    }

    constructor(element) {
        super(element);

        this.distanceScaleThreshold = { min: 0, max: 100 };
        this.scaleIntervalExpand = { from: 1, to: 2.5 };
        this.nearBy = null;
    }

    render() {
        this.setVars();
        this.setEventListeners();
        this.init();
    }

    setVars() {
        this.approachTarget = this.element.querySelector('.js-approach-pointer-target');
    }

    setEventListeners() {}

    lineEq(y2, y1, x2, x1, currentVal) {
        var m = (y2 - y1) / (x2 - x1), b = y1 - m * x1;
        return m * currentVal + b;
    };

    init() {

        this.nearBy = new Nearby(this.element, {

            onProgress: (distance) => {

                const expand = this.lineEq(this.scaleIntervalExpand.from, this.scaleIntervalExpand.to, this.distanceScaleThreshold.max, this.distanceScaleThreshold.min, distance);

                TweenLite.to(this.approachTarget, 1.2, {
                    scale: Math.min(Math.max(this.scaleIntervalExpand.from, expand), this.scaleIntervalExpand.to),
                    ease: Power4.easeOut
                });

            }

        });
    }

}




// WEBPACK FOOTER //
// ./components/approach-pointer/scripts/approach-pointer.js